import { render, staticRenderFns } from "./SamChip.vue?vue&type=template&id=78ec357e&scoped=true&shadow"
import script from "./SamChip.vue?vue&type=script&lang=js&shadow"
export * from "./SamChip.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamChip.vue?vue&type=style&index=0&id=78ec357e&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "78ec357e",
  null
  ,true
)

export default component.exports